import type { DataOptions as VTableOptions } from 'vuetify'

export const itemsPerPageOptions: readonly [number, number, number] = [15, 30, 45] as const
export type ItemsPerPage = typeof itemsPerPageOptions[number]

export class TableOptions implements VTableOptions {
  itemsPerPage: ItemsPerPage | number = itemsPerPageOptions[0]
  /** Нумерация начинается с 1 */
  page: number
  sortBy: Array<string> = []
  sortDesc: Array<boolean> = []

  groupBy: string[]
  groupDesc: boolean[]
  multiSort: boolean
  mustSort: boolean

  constructor(page = 1, itemsPerPage?: ItemsPerPage | number) {
    this.page = page
    if (itemsPerPage) this.itemsPerPage = itemsPerPage
  }
}
